<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5.88629 0H1.11359C0.499526 0 0 0.490604 0 1.0937V3.90618C0 4.5094 0.499526 5 1.11359 5H5.88629C6.50047 5 7 4.5094 7 3.90618V1.0937C7 0.490604 6.50047 0 5.88629 0Z"
        fill="currentColor"/>
    <path
        d="M5.88629 7H1.11359C0.499526 7 0 7.50462 0 8.12507V14.875C0 15.4954 0.499526 16 1.11359 16H5.88629C6.50047 16 7 15.4954 7 14.875V8.12507C7 7.50462 6.50047 7 5.88629 7Z"
        fill="currentColor"/>
    <path
        d="M14.8864 11H10.1137C9.49953 11 9 11.4906 9 12.0938V14.9063C9 15.5094 9.49953 16 10.1137 16H14.8864C15.5005 16 16 15.5094 16 14.9063V12.0938C16 11.4906 15.5005 11 14.8864 11Z"
        fill="currentColor"/>
    <path
        d="M14.8864 0H10.1137C9.49953 0 9 0.504623 9 1.12496V7.87493C9 8.49538 9.49953 9 10.1137 9H14.8864C15.5005 9 16 8.49538 16 7.87493V1.12496C16 0.504623 15.5005 0 14.8864 0V0Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconDashboard"
}
</script>

<style scoped>

</style>